import {connect} from "react-redux";

import Home from "../../components/Home/Home";
import {checkIsLogged, getSociete, getSouscription, logout, setSociete,} from "../../actions/user";
import {clearChatBot} from "../../actions/PlanDemand";
import {getCases} from "../../actions/cases";
import {clearListMessages} from "../../actions/chatCase/messages";
import {clearListDocuments} from "../../actions/chatCase/document";
import {getPraticalSheets, searchSheets} from "../../actions/sheets";
import {setSelectedVideo, setShowAccountModal, setShowOfferModal, setShowVideoModal} from "../../actions/modal";
import {getQuestionsAnswers} from "../../actions/QuestionsAndAnswers";
import {createSouscription} from "../../actions/stripePayment";
import {setShowSheetsAccueil} from "../../actions/SheetsVideosFormations";
import {handleOpenNavItem} from "../../actions/setNavLink";
import {getBlogPosts, searchPosts} from "../../actions/posts";

const MapStateToProps = (state) => ({
    dataUser: state.user.dataUser,
    listCases: state.cases.listCases,
    listCareManager: state.cases.listCareManager,
    listCasesWithManager: state.cases.listCasesWithManager,
    sheetsList: state.sheets.searchSheet,
    postsList: state.posts.searchPosts,
    firstsSheetsOfArray: state.sheets.firstsSheetsOfArray,
    firstsPostsOfArray: state.posts.firstsPostsOfArray,
    showAccountModal: state.modal.showAccountModal,
    showVideoModal: state.modal.showVideoModal,
    selectedVideo: state.modal.selectedVideo,
    showOfferModal: state.modal.showOfferModal,
    tel: state.user.tel,
    cp: state.user.cp,
    address: state.user.address,
    city: state.user.city,
    password: state.user.password,
    newPasswordValue: state.user.newPasswordValue,
    verifiedPassword: state.user.verifiedPassword,
    errorMessage: state.user.errorMessage,
    successMessage: state.user.successMessage,
    redirection: state.user.redirection,
    freeQuestion: state.freeQuestionChatBot.freeQuestion,
    questionsAndAnswers: state.questionsAndAnswers.questionsAndAnswers,
    showSheetsAccueil: state.sheetsvideosformations.showSheetsAccueil,
    societe: state.user.societe,
    navItem: state.navLink.navItem,
});

const MapDispatchToProps = (dispatch) => ({
    logout: () => {
        dispatch(logout());
    },
    clearChatBot: () => {
        dispatch(clearChatBot());
    },
    clearListMessages: () => {
        dispatch(clearListMessages());
    },
    clearListDocuments: () => {
        dispatch(clearListDocuments());
    },
    checkIsLogged: () => {
        dispatch(checkIsLogged());
    },
    getCases: () => {
        dispatch(getCases());
    },
    getPraticalSheets: () => {
        dispatch(getPraticalSheets());
    },
    searchSheet: (sheetsValue) => {
        dispatch(searchSheets(sheetsValue));
    },
    searchPosts: (postsValue) => {
        dispatch(searchPosts(postsValue));
    },
    setShowAccountModal: (bool) => {
        dispatch(setShowAccountModal(bool));
    },
    setShowVideoModal: (bool) => {
        dispatch(setShowVideoModal(bool));
    },
    setSelectedVideo: (url) => {
        dispatch(setSelectedVideo(url));
    },
    getQuestionsAnswers: () => {
        dispatch(getQuestionsAnswers());
    },
    getSouscription: () => {
        dispatch(getSouscription());
    },
    setShowOfferModal: (bool) => {
        dispatch(setShowOfferModal(bool));
    },
    createSouscription: () => {
        dispatch(createSouscription());
    },
    setShowSheetsAccueil: (bool) => {
        dispatch(setShowSheetsAccueil(bool));
    },
    setSociete: (data) => {
        dispatch(setSociete(data));
    },
    getSociete: (data) => {
        dispatch(getSociete(data));
    },
    handleOpenNavItem: (string) => {
        dispatch(handleOpenNavItem(string));
    },
    getBlogPosts: () => {
        dispatch(getBlogPosts());
    }
});

export default connect(MapStateToProps, MapDispatchToProps)(Home);